var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 16.6665C13.6822 16.6665 16.667 13.6818 16.667 9.99984C16.667 6.31794 13.6822 3.33317 10.0003 3.33317C6.31843 3.33317 3.33366 6.31794 3.33366 9.99984C3.33366 13.6818 6.31843 16.6665 10.0003 16.6665ZM10.0003 18.3332C14.6027 18.3332 18.3337 14.6022 18.3337 9.99984C18.3337 5.39746 14.6027 1.6665 10.0003 1.6665C5.39795 1.6665 1.66699 5.39746 1.66699 9.99984C1.66699 14.6022 5.39795 18.3332 10.0003 18.3332Z",
    fill: "#b1b1b1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 8.3335C10.0003 7.87326 10.3734 7.50016 10.8337 7.50016H11.667C12.1272 7.50016 12.5003 7.12707 12.5003 6.66683C12.5003 6.2066 12.1272 5.8335 11.667 5.8335H10.8337C9.45291 5.8335 8.33366 6.95279 8.33366 8.3335V10.0002H7.50033C7.04009 10.0002 6.66699 10.3732 6.66699 10.8335C6.66699 11.2937 7.04008 11.6668 7.50033 11.6668H8.33366V16.6668C8.33366 17.1271 8.70674 17.5002 9.16699 17.5002C9.62724 17.5002 10.0003 17.1271 10.0003 16.6668V11.6668H11.667C12.1272 11.6668 12.5003 11.2937 12.5003 10.8335C12.5003 10.3732 12.1272 10.0002 11.667 10.0002H10.0003V8.3335Z",
    fill: "#b1b1b1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.f1d67346854ebe4b2021efbf902b63b4.svg";
export { ForwardRef as ReactComponent };